import BaseService from '_services/rest/base';

class DashboardService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/dashboard`;
  }

  getQuotationsDashboard(params, type = 'period') {
    const filters = { search: params, type };

    return this.request(`${this.getUrl()}/quotations`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getQuotationsDashboardAlerts(params) {
    return this.request(`${this.getUrl()}/alerts/${params.skip}/${params.take}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getQuotationsStatsDashboard() {
    return this.request(`${this.getUrl()}/stats`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getNotificationsAlerts() {
    return this.request(`${this.getUrl()}/alerts/unread/`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  setReadNotification(quotationId) {
    return this.request(`${this.getUrl()}/alerts/read/${quotationId}`)
      .catch(err => {
        throw err;
      });
  }
}

export default new DashboardService();
